import CryptoJS from 'crypto-js'

class CryptoUtil{
  static aesEncrypt (message, secretKey){
    //对称加密
    const passwordArray = CryptoJS.enc.Utf8.parse(message);
    const secretKeyArray = CryptoJS.enc.Utf8.parse(secretKey);
    const passwordEncrypt = CryptoJS.AES.encrypt(passwordArray, secretKeyArray, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    //不能用 passwordEncrypt.toString()，需转为base64
    const result = CryptoJS.enc.Base64.stringify(passwordEncrypt.ciphertext);
    return result;
  }
}
export default CryptoUtil;



// WEBPACK FOOTER //
// ./src/libs/CryptoUtil.js